<template>
  <div v-if="nstmFatigueValue && !disableFields && !substructureFatigueTable" class="mt-4">
    <v-row>
      <v-col lg="6" md="12">
        <LabelSelect
          noGrid
          id="redundancy"
          label="NF.06 Redundancy"
          v-model="redundancy"
          :refTable="REFERENCE_TABLE.REDUNDANCY"
          :isEditable="isAllowedToEditRedundancy"
      /></v-col>
      <v-col lg="6" md="12">
        <LabelSelect
          noGrid
          id="nstms"
          :showColon="false"
          label="NF.07 NSTM's?"
          v-model="nstmPresent"
          :refTable="REFERENCE_TABLE.NSTM_PRESENT"
      /></v-col>
      <v-col lg="6" md="12">
        <LabelSelect
          noGrid
          id="fatigueDetail"
          label="B.IR.02 Fatigue Details"
          v-model="fatigueDetails"
          :refTable="REFERENCE_TABLE.FATIGUE_DETAILS"
      /></v-col>
      <v-col lg="6" md="12">
        <LabelSelect
          noGrid
          id="complex"
          :showColon="false"
          label="B.IR.04 Complex Feature?"
          v-model="complexFeaturePresent"
          :refTable="REFERENCE_TABLE.COMPLEX_FEATURE"
      /></v-col>
    </v-row>
  </div>
  <v-row v-if="!substructureFatigueTable">
    <v-col class="px-0">
      <v-btn
        :disabled="!isEditable || cannotAddDetail"
        id="btn_addDetails"
        variant="outlined"
        class="mb-2"
        @click="addDetailsFunction()"
        >Add Details</v-btn
      >
      <IconTooltip
        id="icon_noLocationsAvailable"
        icon="fas fa-circle-info"
        iconclass="infoIcon"
        :tooltip="INSPECTION_MESSAGES.NO_FATIGUE_LOCATIONS_AVAILABLE_TO_ADD"
        v-if="isEditable && cannotAddDetail"
      />
    </v-col>
  </v-row>
  <v-row v-if="$vuetify?.display?.mdAndDown && locations?.length">
    <v-data-table
      :id="`nstm-data-table_${unitKey}`"
      v-model:page="pageInspection.page"
      :items-per-page="pageInspection.itemsPerPage"
      v-model:expanded="expandedRows"
      :headers="headersSmall"
      :items="fcDetails"
      class="compactTable padding-xs detailTable"
      v-model:sort-by="sortBy"
      hide-default-footer
      must-sort
      show-expand
      return-object
      @update:sort-by="nstmFooter.setPageValue(1)"
    >
      <template v-slot:[`header.data-table-expand`]="{ column }">
        {{ column.title }}
      </template>
      <template v-slot:[`header.fcKey`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.strUnitKey`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.fcMemType`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.fcMem`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.fcDetail`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.fatigStressCat`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.nstmDetailPresent`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-slot:[`header.fcDescription`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>
      <template v-if="!substructureFatigueTable" v-slot:[`header.action`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="3" />
      </template>

      <template v-slot:expanded-row="{ item }">
        <td :colspan="headers.length">
          <v-form ref="fcDetailForm" v-model="validDetails" class="mt-2" @change="changesDetected = true">
            <v-row>
              <v-col cols="12">
                <LabelText
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelsm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="fcKey"
                  label="NF.08 Key"
                  v-model="item.fcKey"
                  type="number" />
                <LabelSelect
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelsm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="fcLocation"
                  label="NF.09 Location"
                  :isEditable="isEditable && item.isAdd && !spanBySpanFatigueTable"
                  v-model="item.strUnitKey"
                  :options="locations"
                  isRequired
                  @update:modelValue="changesDetected = true" />
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  selectXl="7"
                  selectLg="7"
                  selectMd="6"
                  selectSm="6"
                  id="fcMemberType"
                  label="NF.11 Member Type"
                  :isEditable="isEditable && !item.readOnly"
                  :refTable="REFERENCE_TABLE.FRACTURE_CRITICAL_MEMBER_TYPE"
                  v-model="item.fcMemType"
                  isRequired
                  @update:modelValue="changesDetected = true" />
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  textXl="7"
                  textLg="7"
                  textMd="6"
                  textSm="6"
                  id="memberDetail"
                  label="NF.12 Member Detail"
                  v-model="item.fcDetail"
                  type="textarea"
                  counter="50"
                  maxlength="50"
                  persistentCounter
                  isRequired
                  :isEditable="isEditable && !item.readOnly" />
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  selectXl="7"
                  selectLg="7"
                  selectMd="6"
                  selectSm="6"
                  id="memberStressCat"
                  label="NF.10 Member Stress Category"
                  :isEditable="isEditable && !item.readOnly"
                  :options="fractureCriticalFatigueStressCategory"
                  v-model="item.fatigStressCat"
                  isRequired
                  @update:modelValue="changesDetected = true" />
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  textXl="7"
                  textLg="7"
                  textMd="6"
                  textSm="6"
                  id="member"
                  label="NF.14 Member"
                  v-model="item.fcMem"
                  type="textarea"
                  counter="255"
                  maxlength="255"
                  persistentCounter
                  isRequired
                  :isEditable="isEditable && !item.readOnly" />
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  textXl="7"
                  textLg="7"
                  textMd="6"
                  textSm="6"
                  id="memberDetailCondition"
                  label="NF.15 Member Detail Condition"
                  v-model="item.fcDescription"
                  type="textarea"
                  counter="255"
                  maxlength="255"
                  persistentCounter
                  :isEditable="isEditable && !item.readOnly" />
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  selectXl="7"
                  selectLg="7"
                  selectMd="6"
                  selectSm="6"
                  :showColon="false"
                  id="nstm"
                  label="NF.13 Detail Type"
                  :isEditable="isEditable && !item.readOnly"
                  :refTable="REFERENCE_TABLE.NSTM_DETAIL_PRESENT"
                  v-model="item.nstmDetailPresent"
                  isRequired
                  @update:modelValue="changesDetected = true" />
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  textXl="7"
                  textLg="7"
                  textMd="6"
                  textSm="6"
                  id="memberInspectionProcedures"
                  label="NF.16 Member Inspection Procedures"
                  v-model="item.detailInspProc"
                  isRequired
                  type="textarea"
                  counter="2000"
                  maxlength="2000"
                  persistentCounter
                  :isEditable="isEditable && !item.readOnly"
              /></v-col>
            </v-row>
          </v-form>
        </td>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="rowClass(item)">
          <td class="text-center">
            <template v-if="expandedRows?.length == 0 || !anyDetailEditable">
              <button v-if="!expandedRows?.includes(item)" @click="toggleRow(item)">
                <v-icon :id="`icon_Chevron_Right_${item.uniqueKey}`" icon="fa-solid fa-chevron-right"></v-icon>
              </button>

              <button v-if="expandedRows?.includes(item)" @click="toggleRow(item)">
                <v-icon :id="`icon_Chevron_Down_${item.uniqueKey}`" icon="fa-solid fa-chevron-down"></v-icon>
              </button>
            </template>
          </td>
          <td class="text-center">
            {{ item.fcKey }}
          </td>
          <td class="text-center">{{ getLocationByStrUnitKey(item) }}</td>
          <td class="text-center" style="width: 18%">
            {{
              item?.fcMemType
                ? configStore.getReferenceValue(REFERENCE_TABLE.FRACTURE_CRITICAL_MEMBER_TYPE, item?.fcMemType)
                : ""
            }}
          </td>
          <td v-if="nstmFatigueValue" class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcMem }}</span>
            </div>
          </td>
          <td class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcDetail }}</span>
            </div>
          </td>
          <td class="text-center">
            {{
              item?.fatigStressCat
                ? configStore.getReferenceValue(
                    REFERENCE_TABLE.FRACTURE_CRITICAL_FATIGUE_STRESS_CATEGORY,
                    item?.fatigStressCat,
                    true
                  )
                : ""
            }}
          </td>
          <td class="text-center" style="width: 18%">
            {{
              item.columns?.nstmDetailPresent
                ? configStore.getReferenceValue(REFERENCE_TABLE.NSTM_DETAIL_PRESENT, item.columns?.nstmDetailPresent)
                : ""
            }}
          </td>
          <td class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcDescription }}</span>
            </div>
          </td>
          <td v-if="nstmFatigueValue && !substructureFatigueTable" class="text-center">
            <div style="white-space: nowrap" v-if="!item.readOnly && isEditable">
              <IconTooltip
                id="icon_add"
                icon="fa-solid fa-check"
                :tooltip="item?.isAdd ? 'Add' : 'Update'"
                @click="saveDetail(item)"
              />
              <IconTooltip id="icon_close" icon="fa-solid fa-xmark" tooltip="Close" @click="closeDetail" />
            </div>
            <div
              style="white-space: nowrap"
              v-else-if="isEditable && (expandedRows?.length == 0 || !anyDetailEditable)"
            >
              <IconTooltip id="icon_edit" icon="fa-solid fa-pencil" tooltip="Edit" @click="editDetail(item)" />
              <IconTooltip id="icon_delete" icon="fa-solid fa-trash" tooltip="Delete" @click="deleteDetail(item)" />
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:bottom>
        <DataTableFooter
          ref="nstmFooter"
          id="inspection_nstm_footer"
          :items="fcDetails"
          v-model="pageInspection"
        ></DataTableFooter>
      </template>
    </v-data-table>
  </v-row>
  <v-row v-else>
    <v-data-table
      :id="`nstm-data-table_${unitKey}`"
      v-model:page="pageInspection.page"
      :items-per-page="pageInspection.itemsPerPage"
      v-model:expanded="expandedRows"
      :headers="headers"
      :items="fcDetails"
      class="compactTable padding-xs detailTable"
      v-model:sort-by="sortBy"
      hide-default-footer
      must-sort
      show-expand
      return-object
      @update:sort-by="nstmFooter.setPageValue(1)"
    >
      <template v-slot:[`header.data-table-expand`]="{ column }">
        {{ column.title }}
      </template>
      <template v-slot:[`header.fcKey`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.strUnitKey`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.fcMemType`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.fcMem`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.fcDetail`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.fatigStressCat`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.nstmDetailPresent`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-slot:[`header.fcDescription`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>
      <template v-if="!substructureFatigueTable" v-slot:[`header.action`]="{ column }">
        <DataTableHeader :column="column" :sortBy="sortBy" :lines="2" />
      </template>

      <template v-slot:expanded-row="{ item }">
        <td :colspan="headers.length">
          <v-form ref="fcDetailForm" v-model="validDetails" class="mt-2" @change="changesDetected = true">
            <v-row>
              <v-col cols="6">
                <LabelText
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelsm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="fcKey"
                  label="NF.08 Key"
                  v-model="item.fcKey"
                  type="number"
                />
              </v-col>
              <v-col>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  selectXl="7"
                  selectLg="7"
                  selectMd="6"
                  selectSm="6"
                  id="fcMemberType"
                  label="NF.11 Member Type"
                  :isEditable="isEditable && !item.readOnly"
                  :refTable="REFERENCE_TABLE.FRACTURE_CRITICAL_MEMBER_TYPE"
                  v-model="item.fcMemType"
                  isRequired
                  @update:modelValue="changesDetected = true"
                /> </v-col
            ></v-row>

            <v-row>
              <v-col cols="6">
                <LabelSelect
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelsm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="fcLocation"
                  label="NF.09 Location"
                  :isEditable="isEditable && item.isAdd && !spanBySpanFatigueTable"
                  v-model="item.strUnitKey"
                  :options="locations"
                  isRequired
                  @update:modelValue="changesDetected = true"
                />
              </v-col>
              <v-col>
                <LabelText
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  textXl="7"
                  textLg="7"
                  textMd="6"
                  textSm="6"
                  id="memberDetail"
                  label="NF.12 Member Detail"
                  v-model="item.fcDetail"
                  type="textarea"
                  counter="50"
                  maxlength="50"
                  persistentCounter
                  isRequired
                  :isEditable="isEditable && !item.readOnly"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <LabelSelect
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelsm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="memberStressCat"
                  label="NF.10 Member Stress Category"
                  :isEditable="isEditable && !item.readOnly"
                  :options="fractureCriticalFatigueStressCategory"
                  v-model="item.fatigStressCat"
                  isRequired
                  @update:modelValue="changesDetected = true"
                />
              </v-col>
              <v-col cols="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelsm="6"
                  selectXl="7"
                  selectLg="7"
                  selectMd="6"
                  selectSm="6"
                  :showColon="false"
                  id="nstm"
                  label="NF.13 Detail Type"
                  :isEditable="isEditable && !item.readOnly"
                  :refTable="REFERENCE_TABLE.NSTM_DETAIL_PRESENT"
                  v-model="item.nstmDetailPresent"
                  isRequired
                  @update:modelValue="changesDetected = true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <LabelText
                  labelXl="2"
                  labelLg="2"
                  labelMd="3"
                  labelsm="3"
                  textXl="10"
                  textLg="10"
                  textMd="9"
                  textSm="9"
                  id="member"
                  label="NF.14 Member"
                  v-model="item.fcMem"
                  type="textarea"
                  counter="255"
                  maxlength="255"
                  persistentCounter
                  isRequired
                  :isEditable="isEditable && !item.readOnly"
                />
              </v-col>
            </v-row>
            <v-row
              ><v-col>
                <LabelText
                  labelXl="2"
                  labelLg="2"
                  labelMd="3"
                  labelsm="3"
                  textXl="10"
                  textLg="10"
                  textMd="9"
                  textSm="9"
                  id="memberDetailCondition"
                  label="NF.15 Member Detail Condition"
                  v-model="item.fcDescription"
                  type="textarea"
                  counter="255"
                  maxlength="255"
                  persistentCounter
                  :isEditable="isEditable && !item.readOnly"
                />
              </v-col>
            </v-row>
            <v-row
              ><v-col>
                <LabelText
                  labelXl="2"
                  labelLg="2"
                  labelMd="3"
                  labelsm="3"
                  textXl="10"
                  textLg="10"
                  textMd="9"
                  textSm="9"
                  id="memberInspectionProcedures"
                  label="NF.16 Member Inspection Procedures"
                  v-model="item.detailInspProc"
                  isRequired
                  type="textarea"
                  counter="2000"
                  maxlength="2000"
                  persistentCounter
                  :isEditable="isEditable && !item.readOnly"
              /></v-col>
            </v-row>
          </v-form>
        </td>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="rowClass(item)">
          <td class="text-center">
            <template v-if="expandedRows?.length == 0 || !anyDetailEditable">
              <button v-if="!expandedRows?.includes(item)" @click="toggleRow(item)">
                <v-icon :id="`icon_Chevron_Right_${item.uniqueKey}`" icon="fa-solid fa-chevron-right"></v-icon>
              </button>

              <button v-if="expandedRows?.includes(item)" @click="toggleRow(item)">
                <v-icon :id="`icon_Chevron_Down_${item.uniqueKey}`" icon="fa-solid fa-chevron-down"></v-icon>
              </button>
            </template>
          </td>
          <td class="text-center">
            {{ item.fcKey }}
          </td>
          <td class="text-center">
            {{ getLocationByStrUnitKey(item) }}
          </td>
          <td class="text-center" style="width: 18%">
            {{
              item?.fcMemType
                ? configStore.getReferenceValue(REFERENCE_TABLE.FRACTURE_CRITICAL_MEMBER_TYPE, item?.fcMemType)
                : ""
            }}
          </td>
          <td class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcMem }}</span>
            </div>
          </td>
          <td class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcDetail }}</span>
            </div>
          </td>
          <td class="text-center">
            {{
              item?.fatigStressCat
                ? configStore.getReferenceValue(
                    REFERENCE_TABLE.FRACTURE_CRITICAL_FATIGUE_STRESS_CATEGORY,
                    item?.fatigStressCat,
                    true
                  )
                : ""
            }}
          </td>
          <td class="text-center" style="width: 18%">
            {{
              item?.nstmDetailPresent
                ? configStore.getReferenceValue(REFERENCE_TABLE.NSTM_DETAIL_PRESENT, item?.nstmDetailPresent)
                : ""
            }}
          </td>
          <td class="text-center">
            <div class="ellipsisText">
              <span>{{ item.fcDescription }}</span>
            </div>
          </td>
          <td v-if="nstmFatigueValue && !substructureFatigueTable" class="text-center">
            <div style="white-space: nowrap" v-if="!item.readOnly && isEditable">
              <IconTooltip
                id="icon_add"
                icon="fa-solid fa-check"
                :tooltip="item?.isAdd ? 'Add' : 'Update'"
                @click="saveDetail(item)"
              />
              <IconTooltip id="icon_close" icon="fa-solid fa-xmark" tooltip="Close" @click="closeDetail" />
            </div>
            <div
              style="white-space: nowrap"
              v-else-if="isEditable && (expandedRows?.length == 0 || !anyDetailEditable)"
            >
              <IconTooltip id="icon_edit" icon="fa-solid fa-pencil" tooltip="Edit" @click="editDetail(item)" />
              <IconTooltip id="icon_delete" icon="fa-solid fa-trash" tooltip="Delete" @click="deleteDetail(item)" />
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:bottom>
        <DataTableFooter
          ref="nstmFooter"
          id="inspection_nstm_footer"
          :items="fcDetails"
          v-model="pageInspection"
        ></DataTableFooter>
      </template>
    </v-data-table>
  </v-row>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
</template>
<script>
import { computed, ref, nextTick, watch, toRef, onMounted } from "vue";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { requiredRule } from "@/composables/validationRules";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import { LOGGER } from "@/util/logger";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import { BUTTONS } from "@/constants/CommonWebConstants";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import DataTableFooter from "@/components/common/DataTableFooter.vue";
import { scrollToDataTable } from "@/util/scrollToElement";
import { getFcDetails } from "@/composables/NSTMFatigueData";
import { useSnackbarStore } from "@/stores/snackbar";
import { PERMISSIONS, INSPECTION_LINKS_PERMISSIONS } from "@/rbac";
import { useUserPermissionStore } from "@/stores/userPermission";
import { useNstmDetailsStore } from "@/components/inspection/store/nstmFatigueDetails";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";

export default {
  name: "NSTMFatigueTable",
  props: {
    id: { default: "" },
    substructureFatigueTable: { type: Boolean, default: false },
    spanBySpanFatigueTable: { type: Boolean, default: false },
    unitKey: { type: Number, default: null },
    moduleType: { default: "" },
    disableFields: { type: Boolean, default: false },
  },
  emits: ["nstmFatigueChanged"],
  setup(props, context) {
    const configStore = useConfigStore();
    const inspectionStore = useInspectionStore();
    const snackbarStore = useSnackbarStore();
    const inspectionLinksStore = useInspectionLinksStore();
    let valid = ref(true);
    let nstmFatigueDetailStore = useNstmDetailsStore();
    let headersSmall = ref(
      props.substructureFatigueTable
        ? [
            {
              key: "data-table-expand",
              width: "2%",
            },
            {
              line1: "NF.08",
              line2: "Key",
              line3: null,
              key: "fcKey",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.09",
              line2: "Location",
              line3: null,
              key: "strUnitKey",
              width: "13%",
              sortable: true,
            },
            {
              line1: "NF.11",
              line2: "Member",
              line3: "Type",
              key: "fcMemType",
              width: "8%",
              sortable: true,
            },
            {
              line1: "NF.12",
              line2: "Member",
              line3: "Detail",
              key: "fcDetail",
              width: "16%",
              sortable: true,
            },
            {
              line1: "NF.10",
              line2: "Member",
              line3: "Stress Category",
              key: "fatigStressCat",
              width: "18%",
              sortable: true,
            },
            {
              line1: "NF.13",
              line2: "Detail Type",
              line3: null,
              key: "nstmDetailPresent",
              width: "8%",
              sortable: true,
            },
            {
              line1: "NF.15",
              line2: "Member",
              line3: "Detail Condition",
              key: "fcDescription",
              width: "18%",
              sortable: true,
            },
          ]
        : [
            {
              key: "data-table-expand",
              width: "2%",
            },
            {
              line1: "NF.08",
              line2: "Key",
              line3: null,
              key: "fcKey",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.09",
              line2: "Location",
              line3: null,
              key: "strUnitKey",
              width: "8%",
              sortable: true,
            },
            {
              line1: "NF.11",
              line2: "Member",
              line3: "Type",
              key: "fcMemType",
              width: "6%",
              sortable: true,
            },
            {
              line1: "NF.14",
              line2: "Member",
              line3: null,
              key: "fcMem",
              width: "12%",
              sortable: true,
            },
            {
              line1: "NF.12",
              line2: "Member",
              line3: "Detail",
              key: "fcDetail",
              width: "15%",
              sortable: true,
            },
            {
              line1: "NF.10",
              line2: "Member",
              line3: "Stress Category",
              key: "fatigStressCat",
              width: "17%",
              sortable: true,
            },
            {
              line1: "NF.13",
              line2: "Detail Type",
              line3: null,
              key: "nstmDetailPresent",
              width: "12%",
              sortable: true,
            },
            {
              line1: "NF.15",
              line2: "Member",
              line3: "Detail Condition",
              key: "fcDescription",
              width: "17%",
              sortable: true,
            },
            {
              line1: null,
              line2: "Action",
              line3: null,
              key: "action",
              width: "5%",
              sortable: false,
            },
          ]
    );
    let headers = ref(
      props.substructureFatigueTable
        ? [
            {
              key: "data-table-expand",
              width: "3%",
            },
            {
              line1: "NF.08",
              line2: "Key",
              line3: null,
              key: "fcKey",
              width: "7%",
              sortable: true,
            },
            {
              line1: "NF.09",
              line2: "Location",
              line3: null,
              key: "strUnitKey",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.11",
              line2: "Member Type",
              line3: null,
              key: "fcMemType",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.14",
              line2: "Member",
              line3: null,
              key: "fcMem",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.12",
              line2: "Member Detail",
              line3: null,
              key: "fcDetail",
              width: "15%",
              sortable: true,
            },
            {
              line1: "NF.10",
              line2: "Member Stress Category",
              line3: null,
              key: "fatigStressCat",
              width: "18%",
              sortable: true,
            },
            {
              line1: "NF.13",
              line2: "Detail Type",
              line3: null,
              key: "nstmDetailPresent",
              width: "12%",
              sortable: true,
            },
            {
              line1: "NF.15",
              line2: "Member Detail Condition",
              line3: null,
              key: "fcDescription",
              width: "20%",
              sortable: true,
            },
          ]
        : [
            {
              key: "data-table-expand",
              width: "3%",
            },
            {
              line1: "NF.08",
              line2: "Key",
              line3: null,
              key: "fcKey",
              width: "7%",
              sortable: true,
            },
            {
              line1: "NF.09",
              line2: "Location",
              line3: null,
              key: "strUnitKey",
              width: "8%",
              sortable: true,
            },
            {
              line1: "NF.11",
              line2: "Member Type",
              line3: null,
              key: "fcMemType",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.14",
              line2: "Member",
              line3: null,
              key: "fcMem",
              width: "10%",
              sortable: true,
            },
            {
              line1: "NF.12",
              line2: "Member Detail",
              line3: null,
              key: "fcDetail",
              width: "15%",
              sortable: true,
            },
            {
              line1: "NF.10",
              line2: "Member Stress Category",
              line3: null,
              key: "fatigStressCat",
              width: "18%",
              sortable: true,
            },
            {
              line1: "NF.13",
              line2: "Detail Type",
              line3: null,
              key: "nstmDetailPresent",
              width: "8%",
              sortable: true,
            },
            {
              line1: "NF.15",
              line2: "Member Detail Condition",
              line3: null,
              key: "fcDescription",
              width: "20%",
              sortable: true,
            },
            {
              line1: null,
              line2: "Action",
              line3: null,
              key: "action",
              width: "8%",
              sortable: false,
            },
          ]
    );
    const userPermissionStore = useUserPermissionStore();
    const nstmFatigueValue = toRef(nstmFatigueDetailStore, "nstmFatigueValue");
    const structure = computed(() => inspectionStore.selectedInspection);
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());

    const cannotAddDetail = computed(() => {
      return (
        expandedRows.value?.length > 0 ||
        locations.value?.length <= 0 ||
        (!locations.value.some((location) => Number.parseInt(location.value) === Number.parseInt(props.unitKey)) &&
          props.spanBySpanFatigueTable)
      );
    });

    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return quickSearchStore.hasQuickSearchSucceeded && nstmFatigueValue.value?.brkey && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(nstmFatigueValue.value?.brkey)
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(nstmFatigueValue.value?.brkey)
          );
        }
      },
    });

    let userPermissionForBrKey = computed(() => {
      return userPermissionStore.getUserPermissionByBrkeyFromCache(nstmFatigueValue.value?.brkey);
    });
    const isUserBMSSuperUser = computed(() => {
      return userPermissionStore.checkUserPermission([PERMISSIONS.ROLE_BMS_SUPERUSER], userPermissionForBrKey.value);
    });
    const isAllowedToEditRedundancy = computed(() => {
      return isEditable.value && isUserBMSSuperUser.value;
    });

    const redundancy = computed({
      get() {
        return nstmFatigueValue.value?.redundancy || "";
      },
      set(value) {
        nstmFatigueValue.value.redundancy = value;
      },
    });

    const locations = computed({
      get() {
        return nstmFatigueValue.value?.locations || [];
      },
      set(value) {
        nstmFatigueValue.value.locations = value;
      },
    });

    const nstmPresent = computed({
      get() {
        return nstmFatigueValue.value?.nstmPresent ?? "";
      },
      set(value) {
        nstmFatigueValue.value.nstmPresent = value;
      },
    });

    const complexFeaturePresent = computed({
      get() {
        return nstmFatigueValue.value?.complexFeaturePresent ?? "";
      },
      set(value) {
        nstmFatigueValue.value.complexFeaturePresent = value;
      },
    });

    const fatigueDetails = computed({
      get() {
        return nstmFatigueValue.value?.fatigueDetails ?? "";
      },
      set(value) {
        nstmFatigueValue.value.fatigueDetails = value;
      },
    });

    onMounted(() => {
      getAllDetails();
    });

    const getNewFcInsp = () => {
      return {
        brkey: nstmFatigueValue.value?.brkey,
        strUnitKey: null,
        inspectionId: nstmFatigueValue.value?.inspectionId,
        fcKey: null,
        fatigStressCat: "",
        fcDescription: "",
        fcDetail: "",
        fcMem: "",
        fcMemType: "",
        nstmDetailPresent: "Y",
        updateDateTime: new Date().toISOString(),
        updateUserId: "",
        inspection: null,
      };
    };
    let fcDetails = ref([]);
    let expandedRows = ref([]);
    let fcDetailForm = ref(null);
    let validDetails = ref(false);
    let changesDetected = ref(false);
    const closeConfirm = ref(null);
    const pageInspection = ref({
      itemsPerPage: 30,
      page: 1,
    });
    let nstmFooter = ref(null);
    let previousSort = ref([{ key: "fcKey", order: "asc" }]);
    let sortBy = ref([{ key: "fcKey", order: "asc" }]);
    let snackBarId = ref("");

    function resetSnackbar() {
      snackbarStore.removeMessage(snackBarId.value);
    }
    function addDetailsFunction() {
      inspectionStore.setAddingOrEditing(true);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.NSTM_FATIGUE_DATATABLE,
      });
      isEditing.value = true;
      let newFcInsp = getNewFcInsp();
      newFcInsp.isAdd = true;
      newFcInsp.readOnly = false;
      if (props.spanBySpanFatigueTable) {
        newFcInsp.strUnitKey = Number.parseInt(props.unitKey);
      }
      fcDetails.value.unshift(newFcInsp);
      previousSort.value = sortBy.value.map((x) => x);
      sortBy.value = [];
      expandedRows.value = [newFcInsp];
      scrollToDataTable(`nstm-data-table_${props.unitKey}`);
      changesDetected.value = false;
      nstmFooter.value.setPageValue(1);
      nextTick(() => {
        fcDetailForm.value?.validate();
      });
    }

    const getMaxFCKey = () => {
      const keys = nstmFatigueValue.value?.inspectionFCs
        ? nstmFatigueValue.value?.inspectionFCs.map((fcInsp) => fcInsp?.fcKey)
        : [];

      let maxKey = Math.max(...keys);
      return Number.isFinite(maxKey) ? maxKey : -1;
    };

    function editDetail(detail) {
      previousSort.value = sortBy.value.map((x) => x);

      inspectionStore.setAddingOrEditing(true);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.NSTM_FATIGUE_DATATABLE,
      });
      isEditing.value = true;
      detail.readOnly = false;
      expandedRows.value = [detail];
      changesDetected.value = false;
      nextTick(() => {
        fcDetailForm.value.validate();
      });
      sortBy.value = [];
      moveEditableElementToTop(detail);
      nstmFooter.value.setPageValue(1);
    }

    const moveEditableElementToTop = (detail) => {
      const index = fcDetails.value?.findIndex((a) => a?.strUnitKey === detail.strUnitKey && a?.fcKey === detail.fcKey);
      let editableElement = fcDetails.value[index];
      //then remove that element and use unshift
      fcDetails.value.splice(index, 1);
      fcDetails.value.unshift(editableElement);
    };

    function deleteDetail(detail) {
      const deleteIndex = nstmFatigueValue.value?.inspectionFCs?.findIndex(
        (a) => a?.fcKey === detail.fcKey && a?.strUnitKey === detail.strUnitKey
      );
      if (deleteIndex > -1) {
        nstmFatigueValue.value?.inspectionFCs.splice(deleteIndex, 1);
        context.emit("nstmFatigueChanged", nstmFatigueValue.value);
        expandedRows.value = [];
        fcDetails.value = getFcDetails(props.unitKey, nstmFatigueValue.value?.inspectionFCs);
        updateComplexFeatureNstmPresentAndFatigueDetails();
        context.emit("nstmFatigueChanged", nstmFatigueValue.value);
      }
    }

    function saveDetail(detail) {
      fcDetailForm.value
        .validate()
        .then(() => {
          if (validDetails.value) {
            inspectionStore.setShowValidationSnackbar(false);
            if (!nstmFatigueValue.value?.inspectionFCs?.[0]) {
              //remove null values from array(if any)
              nstmFatigueValue.value.inspectionFCs = nstmFatigueValue.value?.inspectionFCs
                ? nstmFatigueValue.value?.inspectionFCs.filter((a) => !!a)
                : [];
            }
            if (detail.isAdd) {
              detail.fcKey = getMaxFCKey() + 1;
              detail.uniqueKey = detail.strUnitKey + "-" + detail.fcKey;
              nstmFatigueValue.value?.inspectionFCs.push(convertToFCInspObject(detail));
            } else {
              //update existing detail
              const updateIndex = nstmFatigueValue.value?.inspectionFCs.findIndex(
                (a) => a?.strUnitKey === detail.strUnitKey && a?.fcKey === detail.fcKey
              );
              nstmFatigueValue.value?.inspectionFCs.splice(updateIndex, 1, convertToFCInspObject(detail));
            }
            //if all required fields entered - close the expanded row
            updateComplexFeatureNstmPresentAndFatigueDetails();
            context.emit("nstmFatigueChanged", nstmFatigueValue.value);
            expandedRows.value = [];
            fcDetails.value = getFcDetails(props.unitKey, nstmFatigueValue.value?.inspectionFCs);
            changesDetected.value = false;
            inspectionStore.setAddingOrEditing(false);
            resetSnackbar();
          } else {
            inspectionStore.setShowValidationSnackbar(true);
          }
          sortBy.value = previousSort.value?.map((x) => x);
          isEditing.value = false;
        })
        .catch((err) => LOGGER.logException(err));
    }

    const convertToFCInspObject = (details) => {
      let fcInspObject = getNewFcInsp();
      fcInspObject.brkey = details.brkey;
      fcInspObject.strUnitKey = Number.parseInt(details.strUnitKey);
      fcInspObject.inspectionId = details.inspectionId;
      fcInspObject.fcKey = details.fcKey;
      fcInspObject.fatigStressCat = details.fatigStressCat;
      fcInspObject.fcDescription = details.fcDescription;
      fcInspObject.fcDetail = details.fcDetail;
      fcInspObject.fcMem = details.fcMem;
      fcInspObject.fcMemType = details.fcMemType;
      fcInspObject.nstmDetailPresent = details.nstmDetailPresent;
      fcInspObject.detailInspProc = details.detailInspProc;
      fcInspObject.updateDateTime = new Date().toISOString();
      fcInspObject.updateUserId = details.updateUserId;
      fcInspObject.inspection = details.inspection;
      return fcInspObject;
    };

    const rowClass = (data) => {
      return expandedRows.value?.find((a) => a.uniqueKey === data.uniqueKey) ? "rowSelect" : "rowUnselect";
    };

    const anyDetailEditable = computed(() => {
      return expandedRows.value?.find((element) => !element.readOnly);
    });

    const fractureCriticalFatigueStressCategory = computed(() => {
      return configStore.getReferenceValues(
        REFERENCE_TABLE.FRACTURE_CRITICAL_FATIGUE_STRESS_CATEGORY,
        null,
        null,
        true
      );
    });

    const updateComplexFeatureNstmPresentAndFatigueDetails = () => {
      complexFeaturePresent.value = nstmFatigueValue.value?.inspectionFCs?.some(
        (fc) => fc.nstmDetailPresent === "B" || fc.nstmDetailPresent === "C"
      )
        ? "Y"
        : "N";

      nstmPresent.value = nstmFatigueValue.value?.inspectionFCs?.some(
        (fc) => fc.nstmDetailPresent === "Y" || fc.nstmDetailPresent === "B"
      )
        ? "Y"
        : "N";
      fatigueDetails.value = nstmFatigueValue.value?.inspectionFCs?.some(
        (fc) => fc.fatigStressCat === "E" || fc.fatigStressCat === "E'"
      )
        ? "Y"
        : "N";
    };

    const closeDetail = () => {
      if (isEditable.value && changesDetected.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              fcDetails.value = getFcDetails(props.unitKey, nstmFatigueValue.value?.inspectionFCs);

              expandedRows.value = [];
              changesDetected.value = false;
              inspectionStore.setAddingOrEditing(false);
              resetSnackbar();
              sortBy.value = previousSort.value?.map((x) => x);
              isEditing.value = false;
            }
          });
      } else {
        fcDetails.value = getFcDetails(props.unitKey, nstmFatigueValue.value?.inspectionFCs);
        expandedRows.value = [];
        inspectionStore.setAddingOrEditing(false);
        resetSnackbar();
        sortBy.value = previousSort.value?.map((x) => x);
        isEditing.value = false;
      }
    };
    const toggleRow = (detail) => {
      if (expandedRows.value.includes(detail)) {
        const index = expandedRows.value?.findIndex((d) => d.uniqueKey == detail.uniqueKey);
        expandedRows.value.splice(index, 1);
      } else {
        expandedRows.value.push(detail);
      }
    };

    const getAllDetails = () => {
      expandedRows.value = [];
      fcDetails.value = getFcDetails(props.unitKey, nstmFatigueValue.value?.inspectionFCs);
    };

    const getLocationByStrUnitKey = (item) => {
      return locations?.value?.find((a) => a.value == item?.strUnitKey)?.title;
    };

    let isEditing = computed({
      get() {
        return inspectionLinksStore.isAddingOrEditingNstmFatigue;
      },
      set(value) {
        inspectionLinksStore.isAddingOrEditingNstmFatigue = value;
      },
    });

    watch(
      () => nstmFatigueValue.value?.inspectionFCs,
      (val) => {
        if (val != null) {
          fcDetails.value = getFcDetails(props.unitKey, val);
        }
      },

      { immediate: true }
    );
    return {
      cannotAddDetail,
      headersSmall,
      headers,
      fatigueDetails,
      fractureCriticalFatigueStressCategory,
      editDetail,
      deleteDetail,
      saveDetail,
      addDetailsFunction,
      locations,
      REFERENCE_TABLE,
      configStore,
      structure,
      requiredRule,
      valid,
      fcDetails,
      expandedRows,
      rowClass,
      anyDetailEditable,
      isEditable,
      closeDetail,
      fcDetailForm,
      validDetails,
      changesDetected,
      closeConfirm,
      BUTTONS,
      getFcDetails,
      inspectionStore,
      INSPECTION_MESSAGES,
      toggleRow,
      pageInspection,
      nstmFooter,
      sortBy,
      getAllDetails,
      redundancy,
      isAllowedToEditRedundancy,
      nstmFatigueValue,
      nstmPresent,
      complexFeaturePresent,
      getLocationByStrUnitKey,
    };
  },
  components: {
    LabelSelect,
    LabelText,
    IconTooltip,
    ConfirmDialog,
    DataTableHeader,
    DataTableFooter,
  },
};
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;
.detailTable :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.detailTable :deep(button:focus) {
  outline: none !important;
}
.alignCenter {
  text-align: center;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}
</style>
